module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docendo-connection-indicator"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_connected),
      expression: "!is_connected"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "connection_lost"
    }
  }, [_vm._v("Genopretter forbindelse...")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f19439c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocendoConnectionIndicator.vue
// module id = 2040
// module chunks = 1